/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Final_TitleInputs */

const en_why_listening_final_title = /** @type {(inputs: Why_Listening_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start listening to everything you read.`)
};

const es_why_listening_final_title = /** @type {(inputs: Why_Listening_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza a escuchar todo lo que lees.`)
};

/**
* | output |
* | --- |
* | "Start listening to everything you read." |
*
* @param {Why_Listening_Final_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_final_title = /** @type {((inputs?: Why_Listening_Final_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Final_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_final_title(inputs)
	return en_why_listening_final_title(inputs)
});